import { createContext } from 'react';

export type Sport = 'baseball' | 'football' | 'basketball';

export interface SportThemeContextType {
  currentSport: Sport;
  setSport: (sport: Sport) => void;
}

export const SportThemeContext = createContext<SportThemeContextType | undefined>(undefined);